// Fit a local circular area using Web Mercator world pixels (256px at zoom 0).
// Setting center and zoom together avoids intermediate regional-bound clamping.
export function watchZoneCamera(zone, width, height) {
  if (!zone || ![zone.lat, zone.lng, width, height].every(Number.isFinite) || width <= 108 || height <= 108) return null;
  const radius = zone.radius || 5000;
  if (!Number.isFinite(radius) || radius <= 0 || Math.abs(zone.lat) >= 85) return null;
  const latDelta = radius / 111320;
  const lngDelta = latDelta / Math.cos(zone.lat * Math.PI / 180);
  const worldY = latitude => {
    const sin = Math.sin(Math.max(-85, Math.min(85, latitude)) * Math.PI / 180);
    return 128 - 128 * Math.log((1 + sin) / (1 - sin)) / (2 * Math.PI);
  };
  const spanX = 256 * 2 * lngDelta / 360;
  const spanY = Math.abs(worldY(zone.lat + latDelta) - worldY(zone.lat - latDelta));
  const zoom = Math.floor(Math.log2(Math.min((width - 108) / spanX, (height - 108) / spanY)));
  return { center: { lat: zone.lat, lng: zone.lng }, zoom: Math.max(9, Math.min(18, zoom)) };
}
